import { connect } from "react-redux";
import React, { useCallback, useState } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { captureErrorMessage } from "@/lib/helpers/captureErrorMessage";
import CardSecondary from "@/ui/Card/CardSecondary";
import dayjs from "@/lib/helpers/dayjs";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import { getLocalTimezone } from "@/redux/reducers/authReducer";
import { showToast } from "@/providers/ToastProvider";

import { EarlierAppointmentInfo } from "../../Schedule/AppointmentTimePicker/EarlierAppointmentInfo";

import ScheduleCall from "./ScheduleCall";
import "./styles.scss";

const ReferAnotherPatientOrScheduleAppointment = ({
  currentStepName,
  sharedWorkflowData,
  update_state_and_get_next_node,
}) => {
  // driven by availability component
  const [selectedAppointment, setSelectedAppointment] = useState();
  const timezone = getLocalTimezone();
  const workflow_state = sharedWorkflowData.workflow_instance.state;

  if (!workflow_state.patient_info) {
    workflow_state.patient_info = {
      first_name: "",
      last_name: "",
    };
  }

  const handleScheduleSession = useCallback(async () => {
    const dateStr = `${selectedAppointment.year}-${selectedAppointment.month}-${selectedAppointment.day} ${selectedAppointment.start_time}`;
    const utcDatetime = dayjs.tz(dateStr, "YYYY-MM-DD HH:mm", timezone).utc();

    // Defensive programming, validate date to prevent invalid appointments from being scheduled
    if (!utcDatetime.isValid()) {
      captureErrorMessage("Invalid appointment date during HCP flow", dateStr);
      showToast([
        {
          heading: "Invalid appointment date, please try again.",
          variant: "error",
        },
      ]);

      return;
    }

    const data = {
      appointment_confirmed: true,
      call_allotted_time: selectedAppointment["allotted_time"],
      call_date: utcDatetime.format("YYYY-MM-DD"),
      call_provider_id: selectedAppointment["provider_username"],
      call_time: utcDatetime.format("HH:mm"),
      call_timezone: timezone,
      provider_name: selectedAppointment["provider_name"],
      save_call: true,
    };

    update_state_and_get_next_node(data, currentStepName);
  }, [selectedAppointment, timezone, update_state_and_get_next_node, currentStepName]);

  const handleSkipStep = useCallback(async () => {
    const state = { save_call: false };

    await update_state_and_get_next_node(state, currentStepName);
  }, [update_state_and_get_next_node, currentStepName]);

  return (
    <div className="container hcp-mobile-container px-sm-3 py-sm-5">
      <CardSecondary className="HCPWorkflowShared-card">
        <div className="ScheduleCallOrSkip-header_container">
          <div className="HCPWorkflowShared-header_container">
            <h1 className="HCPWorkflowShared-title">
              Would you like to schedule{" "}
              <span data-private style={{ display: "inline" }}>
                {sharedWorkflowData.workflow_instance.state.patient_info?.first_name}
                ’s{" "}
              </span>
              first session?
            </h1>

            <p className="HCPWorkflowShared-sub_title">
              You can do this now or let the patient schedule later.
            </p>
          </div>
        </div>

        <ScheduleCall
          selectedAppointment={selectedAppointment}
          setSelectedAppointment={setSelectedAppointment}
          sharedWorkflowData={sharedWorkflowData}
          timezone={timezone}
        />

        <div className="tw:flex tw:gap-3.5">
          <Button2 onPress={handleSkipStep} variant="text">
            Skip this step
          </Button2>

          <Button2
            isDisabled={!selectedAppointment}
            onPress={handleScheduleSession}
            variant="primary"
            {...getAutomationDataAttr("HCPScheduleSessionButton")}
          >
            Schedule Session
          </Button2>
        </div>

        <EarlierAppointmentInfo />
      </CardSecondary>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    configs: state.configs,
  };
};

export default connect(mapStateToProps)(ReferAnotherPatientOrScheduleAppointment);
